// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Modal$DvmAdminFrontendFr from "../../../../../../common/components/App_Modal.bs.js";
import * as App_Table$DvmAdminFrontendFr from "../../../../../../common/components/table/App_Table.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_Table_Head$DvmAdminFrontendFr from "../../../../../../common/components/table/App_Table_Head.bs.js";
import * as App_Table_Types$DvmAdminFrontendFr from "../../../../../../common/components/table/App_Table_Types.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as App_Table_Simple$DvmAdminFrontendFr from "../../../../../../common/components/table/App_Table_Simple.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Flash_Detail_Api$DvmAdminFrontendFr from "../../../../../flash/detail/Flash_Detail_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../../../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_ModelVersion$DvmAdminFrontendFr from "../../../../../../intl/messages/modelVersion/Messages_ModelVersion.bs.js";
import * as Messages_Orders_DealerRequest$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_DealerRequest.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr from "../create/Order_Detail_Bonus_DealerRequest_Create_Api.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Documents_PdfView$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Documents_PdfView.bs.js";

var headersConfiguration_0 = App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("documentName", undefined, undefined, undefined, undefined, undefined, Messages_Orders_DealerRequest$DvmAdminFrontendFr.documentName);

var headersConfiguration_1 = {
  hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("type", undefined, undefined, undefined, undefined, undefined, Messages_ModelVersion$DvmAdminFrontendFr._type),
  tl: {
    hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell("comment", undefined, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.comment),
    tl: /* [] */0
  }
};

var headersConfiguration = {
  hd: headersConfiguration_0,
  tl: headersConfiguration_1
};

function Order_Detail_Bonus_DealerRequest_Documents_Modal(Props) {
  var onClose = Props.onClose;
  var actionId = Props.actionId;
  var documents = Props.documents;
  var intl = ReactIntl.useIntl();
  var match = React.useState(function () {
        return null;
      });
  var setModal = match[1];
  var match$1 = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$2 = match$1[0];
  var userManager = match$2.userManager;
  var selectedRole = match$2.selectedRole;
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDocumentTypes = match$3[1];
  var documentTypes = match$3[0];
  var match$4 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setFetchedFlash = match$4[1];
  var fetchedFlash = match$4[0];
  React.useEffect((function () {
          Belt_Option.mapWithDefault(actionId, undefined, (function (x) {
                  Flash_Detail_Api$DvmAdminFrontendFr.fetchFlash(x, userManager, setFetchedFlash, selectedRole, /* NonFleet */1);
                }));
        }), []);
  React.useEffect((function () {
          if (typeof fetchedFlash !== "number" && fetchedFlash.TAG === /* Ok */0) {
            Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr.fetchDocumentTypes(userManager, setDocumentTypes, selectedRole, Belt_Option.getWithDefault(fetchedFlash._0.requestType, ""));
          }
          
        }), [fetchedFlash]);
  var convertTable = function (param) {
    return {
            TAG: /* Ok */0,
            _0: Belt_List.map(documents, (function (item) {
                    var fileType = App_Types_Result$DvmAdminFrontendFr.mapWithDefault(documentTypes, "-", (function (docTypes) {
                            return Belt_Option.mapWithDefault(Belt_List.getBy(docTypes, (function (x) {
                                              return x.fileType === Belt_Option.getWithDefault(item.fileType, "-");
                                            })), "-", (function (x) {
                                          return x.fileLabel;
                                        }));
                          }));
                    return App_Table_Types$DvmAdminFrontendFr.makeRow((function (param) {
                                  Curry._1(setModal, (function (param) {
                                          return React.createElement(Order_Detail_Bonus_DealerRequest_Documents_PdfView$DvmAdminFrontendFr.make, {
                                                      onClose: (function (param) {
                                                          Curry._1(setModal, (function (param) {
                                                                  return null;
                                                                }));
                                                        }),
                                                      item: item,
                                                      fileType: fileType
                                                    });
                                        }));
                                }), undefined, undefined, Belt_List.mapWithIndex({
                                    hd: Belt_Option.getWithDefault(item.fileName, ""),
                                    tl: {
                                      hd: fileType,
                                      tl: {
                                        hd: Belt_Option.getWithDefault(item.comment, ""),
                                        tl: /* [] */0
                                      }
                                    }
                                  }, (function (index, content) {
                                      return App_Table$DvmAdminFrontendFr.makeCell(Belt_Option.map(Belt_List.get(headersConfiguration, index), (function (param) {
                                                        return param.align;
                                                      })), undefined, undefined, content);
                                    })));
                  }))
          };
  };
  return React.createElement(React.Fragment, undefined, React.createElement(App_Modal$DvmAdminFrontendFr.make, {
                  open: true,
                  onClose: onClose,
                  title: intl.formatMessage(Messages_Orders_DealerRequest$DvmAdminFrontendFr.viewDocumentsModalTitle, {
                        actionId: actionId
                      }),
                  minWidth: "1000px",
                  children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                        show: App_Types_Result$DvmAdminFrontendFr.isPending(documentTypes) || App_Types_Result$DvmAdminFrontendFr.isPending(fetchedFlash),
                        children: React.createElement(App_Table_Simple$DvmAdminFrontendFr.make, {
                              headers: headersConfiguration,
                              content: convertTable(undefined),
                              width: "100%",
                              height: "55vh"
                            })
                      })
                }), match[0]);
}

var Api;

var make = Order_Detail_Bonus_DealerRequest_Documents_Modal;

export {
  Api ,
  headersConfiguration ,
  make ,
}
/* headersConfiguration Not a pure module */
